import { createRef } from 'react';

export const navigationRef = createRef();

export function navigate(path) {
  if (navigationRef.current) {
    navigationRef.current(path);
  }
}
